// extracted by mini-css-extract-plugin
module.exports = {"description":"ConfirmTenderClose_description__2dX_5"};